import { render } from "./smartDetail.vue?vue&type=template&id=2bca534c"
import script from "./smartDetail.vue?vue&type=script&lang=js"
export * from "./smartDetail.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WSS-BuildAgent\\_work\\5\\s\\Sureload Admin\\sureload-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__